var _mask, _path, _mask2, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1385_17869",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.45283 18C5.20274 18 5 17.7973 5 17.5472L5 6.83018C5 4.16255 7.16255 2 9.83019 2L10.1008 2C12.7685 2 14.931 4.16255 14.931 6.83018L14.931 13.1698C14.931 15.8375 12.7685 18 10.1008 18L5.45283 18Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45283 18C5.20274 18 5 17.7973 5 17.5472L5 6.83018C5 4.16255 7.16255 2 9.83019 2L10.1008 2C12.7685 2 14.931 4.16255 14.931 6.83018L14.931 13.1698C14.931 15.8375 12.7685 18 10.1008 18L5.45283 18Z",
    stroke: "url(#paint0_linear_1385_17869)",
    strokeWidth: 1.81132,
    mask: "url(#path-1-inside-1_1385_17869)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_1385_17869",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5339 8.14619C12.5339 9.48001 11.4527 10.5613 10.1188 10.5613L7.85003 10.5613C7.59994 10.5613 7.3972 10.3585 7.3972 10.1084L7.3972 6.81228C7.3972 5.47846 8.47848 4.39719 9.81229 4.39719L10.1188 4.39719C11.4527 4.39719 12.5339 5.47846 12.5339 6.81228L12.5339 8.14619Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5339 8.14619C12.5339 9.48001 11.4527 10.5613 10.1188 10.5613L7.85003 10.5613C7.59994 10.5613 7.3972 10.3585 7.3972 10.1084L7.3972 6.81228C7.3972 5.47846 8.47848 4.39719 9.81229 4.39719L10.1188 4.39719C11.4527 4.39719 12.5339 5.47846 12.5339 6.81228L12.5339 8.14619Z",
    stroke: "url(#paint1_linear_1385_17869)",
    strokeWidth: 1.81132,
    mask: "url(#path-2-inside-2_1385_17869)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1385_17869",
    x1: 5,
    y1: 10,
    x2: 14.931,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68BAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253A4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1385_17869",
    x1: 9.96557,
    y1: 10.5613,
    x2: 9.96557,
    y2: 4.39719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68BAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253A4E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.84fc1f9e97850020a453f46b3bca1efd.svg";
export { ForwardRef as ReactComponent };